module.exports = __webpack_public_path__ + "img/canbadge_triangle_w70mm_line.7f652a23.png";